import { AI_BUILDER_PROGRAM } from "@/data/aiBuilderPlaybook";
import { S2PElevateDeck } from "@/pages/S2PElevateAI";

const AIBuilderPlaybook = () => (
  <S2PElevateDeck
    program={AI_BUILDER_PROGRAM}
    config={{
      brand: "tech-leaders",
      storageNamespace: "ai-builder-playbook-v1",
      analyticsVariant: "tech-leaders-ai-builder",
      seoTitle: "The AI Builder Playbook | From Job Brief to Verified Prototype",
      seoDescription: "A 90-minute Tech Leaders training that combines safe AI workspaces, meta-prompting, vibe coding, verification, and handoff into one end-to-end build method.",
      seoKeywords: [
        "AI Builder Playbook",
        "AI prototyping",
        "meta prompting",
        "Claude Code training",
        "vibe coding",
        "AI engineering for leaders",
        "AI prototype verification",
      ],
      coverEyebrow: "Tech Leaders · The AI Builder Playbook",
      coverTitle: "The AI Builder Playbook",
      coverAudience: "From Job Brief to Verified Prototype",
      contentsEyebrow: "Tech Leaders · Build with evidence",
      contentsTitle: "Five modules",
      sessionNoun: "Module",
      finishEyebrow: "AI Builder Playbook complete",
      brandHref: "/ai-30/program",
      brandLinkLabel: "Open the Longhand AI roadmap",
      exitHref: "/ai-30/program",
      exitLabel: "Longhand AI",
      finishCtaHref: "/ai-30/program/ai-tune-up",
      finishCtaLabel: "Check your next AI Gear",
      guideHref: null,
    }}
  />
);

export default AIBuilderPlaybook;
